import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    step: 1,
    stepOneData: {
        availability: null
    },
    stepTwoData: {
        minimum_pay_range: "",
        maximum_pay_range: ""
    },
    stepThreeData: {
        seniority: 'INTERMEDIATE',
        specialization: null,
    },
    stepFourData: {
        total_experience: new Date().getFullYear()
    },
    stepFiveData: {
        experience: {}
    },
    stepSixData: {
        cv_id: null,
        linkedin_url: "",
        link_to_cv: "",
        updated_cv: null,
    },
    stepSevenData: {
        english_level: "BEGINNER"
    },
    stepEightData: {
        first_name: "",
        last_name: "",
        email: "",
        country: 8,
        mobile: "",
        agree: false,
        countries: [],
        isCountryLoading: true
    }
};

export const findJobSlice = createSlice({
    name: "findJob",
    initialState,
    reducers: {
        setFormStep: (state, { payload }) => {
            return {
                ...state,
                step: payload
            }
        },
        setFormData: (state, { payload }) => {
            const { step } = state;
            const { formData } = payload;
            return {
                ...state,
                ...(step === 1 && { stepOneData: { ...state.stepOneData, ...formData } }),
                ...(step === 2 && { stepTwoData: { ...state.stepTwoData, ...formData } }),
                ...(step === 3 && { stepThreeData: { ...state.stepThreeData, ...formData } }),
                ...(step === 4 && { stepFourData: { ...state.stepFourData, ...formData } }),
                ...(step === 5 && { stepFiveData: { ...state.stepFiveData, ...formData } }),
                ...(step === 6 && { stepSixData: { ...state.stepSixData, ...formData } }),
                ...(step === 7 && { stepSevenData: { ...state.stepSevenData, ...formData } }),
                ...(step === 8 && { stepEightData: { ...state.stepEightData, ...formData } }),
            }

        },
        prevStep: (state) => {
            const { step } = state;
            return {
                ...state,
                step: step - 1
            }
        },
        nextStep: (state) => {
            const { step } = state;
            return {
                ...state,
                step: step + 1
            }
        },
        setExperience: (state, { payload }) => {
            const { tech, years, toggle } = payload
            if (state.stepFiveData.experience[tech] && toggle) {
                delete state.stepFiveData.experience[tech]
            } else {
                state.stepFiveData.experience[tech] = years || null;
            }
        },
        loadCountries: (state, { payload }) => {
            state.stepEightData.countries = (payload || []).map(country => ({ label: country.name, value: country.id, code: country.code }));
        },
        resetJobForm: () => {
            return initialState;
        }
    },
});

export const {
    loadCountries,
    setFormStep,
    setFormData,
    nextStep,
    prevStep,
    resetJobForm,
    setExperience,
} = findJobSlice.actions;
export default findJobSlice.reducer;